import _objectSpread from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { useSingleSelectListState as $ijHKZ$useSingleSelectListState } from "@react-stately/list";
import { useRef as $ijHKZ$useRef } from "react";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

var $76f919a04c5a7d14$exports = {};
$parcel$export($76f919a04c5a7d14$exports, "useTabListState", function () {
  return $76f919a04c5a7d14$export$4ba071daf4e486;
});

function $76f919a04c5a7d14$export$4ba071daf4e486(props) {
  var state = $ijHKZ$useSingleSelectListState(_objectSpread({}, props, {
    suppressTextValueWarning: true
  }));
  var selectionManager = state.selectionManager,
      collection = state.collection,
      currentSelectedKey = state.selectedKey;
  var lastSelectedKey = $ijHKZ$useRef(currentSelectedKey); // Ensure a tab is always selected (in case no selected key was specified or if selected item was deleted from collection)

  var selectedKey = currentSelectedKey;

  if (selectionManager.isEmpty || !collection.getItem(selectedKey)) {
    selectedKey = collection.getFirstKey();
    selectionManager.replaceSelection(selectedKey);
  } // If the tablist doesn't have focus and the selected key changes or if there isn't a focused key yet, change focused key to the selected key if it exists.


  if (selectionManager.focusedKey == null || !selectionManager.isFocused && selectedKey !== lastSelectedKey.current) selectionManager.setFocusedKey(selectedKey);
  lastSelectedKey.current = selectedKey;
  return state;
}

export { $76f919a04c5a7d14$export$4ba071daf4e486 as useTabListState };